import React, { useEffect, useState } from 'react'
//*Material
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import { Backdrop, CircularProgress } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Divider from '@material-ui/core/Divider'
import DataTable from 'react-data-table-component'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
//*antd
import Modal from 'antd/es/modal';
//*Styles and Assets
import { TelematicsStyles } from './TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import * as TelematicsActions from '../../actions/telematics/TelematicsActions'
//*Components
import TopBarNav from '../common/TopBarNav'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { customStyleSecondary } from '../common/CommonStyles'

const TelematicsAsignTechnician = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory()
    const { match: { params } } = props;
    const [openBackdrop, setOpenBackdrop] = useState(false);

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    useEffect(() => {
        //handleOpenBackdrop()
        const newRoute = {
            path: '/telematics/UnasignTechnician/',
            linkLegend: t('telematicsDetail.unAsignTechnician'),
            urlParams: [{ key: 'instalationId', value: props.match.params.instalationId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Technicians_By_Order(props.userLanguage, props.userToken, params.instalationId, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    //*First Render Functions
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const handleDelete = (installerId) => {
        handleOpenBackdrop()
        props.actions.delete_Assigned_Technician(props.userLanguage, props.userToken, installerId, params.instalationId, onError, onSuccessDelete)
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessDelete = (response) => {
        handleCloseBackdrop()
        props.actions.fetch_Technicians_By_Order(props.userLanguage, props.userToken, params.instalationId, onError, onSuccess)
        Modal.success({
            title: t('commonMessages.deletedSucc')
        })
    }

    //*Funtions Error & Navigation
    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.alert500')}</Typography>
                    })
                    break
                default:
                    break
            }
        }
    }

    const technicianColumns = [
        {
            name: t('telematicsInstallers.technicianName'),
            selector: 'name',
            sortable: true,
            cell: row => row.name
        },
        {
            name: t('common.email'),
            selector: 'email',
            sortable: true,
            cell: row => row.email
        },
        {
            name: "",
            center: true,
            width: '150px',
            cell: row => (buttonForColumns(row))
        }
    ]

    const buttonForColumns = (row) => {
        return (
            <div>
                <Tooltip title={t('common.delete')}>
                    <IconButton style={{ color: '#BF2E2E' }} onClick={() => handleDelete(row.id)}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid item xs={12}><br /></Grid>
                <Container className={classes.generalBorder}>
                    <Grid container item xs={12} spacing={3} >
                        <Grid item xs={12} >
                            <p className={classes.titles}>{t(`telematicsDetail.unAsignTechnician`)}</p>
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid container spacing={1}>
                        <Grid item xs={12} >
                            <DataTable
                                columns={technicianColumns}
                                defaultSortField="name"
                                customStyles={customStyleSecondary}
                                data={props.techniciansByOrder}
                                highlightOnHover
                                pointerOnHover
                                dense
                                responsive
                                striped
                                noHeader
                                pagination
                                paginationComponentOptions={paginationOptions}
                                NosubHeader
                                noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                            />
                            {
                                props.techniciansByOrder && props.techniciansByOrder.length < 1 && (
                                    <Grid container item xs={12}><br /></Grid>
                                )
                            }
                        </Grid>
                    </Grid>
                </Container>
                <Grid item xs={12}><br /></Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    techniciansByOrder: state.TelematicsReducer.techniciansByOrder,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(TelematicsAsignTechnician))